import type { CSSProperties, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL } from '@sorare/core/src/atoms/typography';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const Header = styled(Horizontal).attrs({ center: true })`
  width: 100%;
  padding-bottom: var(--double-unit);
  border-bottom: 1px solid var(--c-nd-150);
`;

const Root = styled(Vertical).attrs({ center: true })`
  gap: var(--double-unit);
  padding: var(--triple-unit);
  background:
    linear-gradient(to bottom, transparent 77%, var(--c-black) 100%),
    var(--c-background-image) bottom center/100% 100% no-repeat;
  overflow: hidden;
  border-radius: var(--double-unit);
  @container ${laptopAndAbove} {
    gap: var(--triple-unit);
  }
`;

const FullWidthWrapper = styled(Horizontal)`
  justify-content: start;
  width: 100%;
`;

type Props = {
  bgImage: string;
  title: ReactNode;
  children: ReactNode;
};

export const DailyDealsBlock = ({ bgImage, title, children }: Props) => {
  return (
    <Root
      style={
        {
          '--c-background-image': `url(${bgImage})`,
        } as CSSProperties
      }
    >
      <Header>
        <BrandL>
          <FormattedMessage
            id="commonCard.DailyDeals.title"
            defaultMessage="Common"
          />
        </BrandL>
      </Header>
      <FullWidthWrapper>{title}</FullWidthWrapper>
      {children}
    </Root>
  );
};
